<div class="container">
  <table mat-table [dataSource]="users" class="mat-elevation-z8 rtab">

    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef> Username </th>
      <td mat-cell *matCellDef="let element"> 
        {{element.username}}
      </td>
    </ng-container>
  
    <!-- Name Column -->
    <ng-container matColumnDef="roles">
      <th mat-header-cell *matHeaderCellDef> Active roles</th>
      <td mat-cell *matCellDef="let element">
        {{element.roles}}
      </td>
    </ng-container>
  
    <!-- Symbol Column -->
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
       <button mat-raised-button (click)="openDialog(element)">
         Edit Roles
       </button>
      </td>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>